import { Box, InputAdornment, FormControlLabel, Checkbox } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useL10n } from '@uplift/hooks';
import { useActiveSinkId, useVideoContext } from '../../../hooks';
import { MediaDeviceTypes } from '@uplift/types';
import { SelectRaw } from '@uplift/ui-v2';
import { LocalVideoPreview } from '../../../components';
import React from 'react';
import { MEDIA_DEFAULT_OPTION } from './media-setup.component';
import { MediaSetupProps } from './media-setup.props';

import MicIcon from '@mui/icons-material/Mic';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VideocamIcon from '@mui/icons-material/Videocam';

export const MediaSetupDesktop: React.VFC<MediaSetupProps> = ({
  audioInputOptions,
  audioOutputOptions,
  videoInputOptions,
  displayBlurToggle,
  localAudioInputDeviceId,
  localVideoInputDeviceId,
  replaceAudioInputTrack,
  replaceLocalVideoTrack
}) => {
  const l10n = useL10n();
  const { activeSinkId, setActiveSinkId } = useActiveSinkId();
  const { isVideoFilterEnabled, toggleVideoFilter } = useVideoContext();

  return (
    <Box>
      <Box mb="30px">
        <LocalVideoPreview identity={l10n.sessions.you} />
      </Box>
      <Grid container spacing={3}>
        <Grid container spacing={3} size={{ xs: 12, md: 9 }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <SelectRaw
              fullWidth
              label={l10n.sessions.microphone}
              name={MediaDeviceTypes.audioInput}
              value={localAudioInputDeviceId || MEDIA_DEFAULT_OPTION.value}
              onChange={(e) => replaceAudioInputTrack(e.target.value as string)}
              items={audioInputOptions}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <MicIcon />
                    </InputAdornment>
                  )
                }
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <SelectRaw
              fullWidth
              label={l10n.sessions.speaker}
              name={MediaDeviceTypes.audioOutput}
              onChange={(e) => setActiveSinkId(e.target.value as string)}
              value={activeSinkId || MEDIA_DEFAULT_OPTION.value}
              items={audioOutputOptions}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <VolumeUpIcon />
                    </InputAdornment>
                  ),
                }
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <SelectRaw
              fullWidth
              label={l10n.sessions.camera}
              name={MediaDeviceTypes.videoInput}
              value={localVideoInputDeviceId || MEDIA_DEFAULT_OPTION.value}
              onChange={(e) => replaceLocalVideoTrack(e.target.value as string)}
              items={videoInputOptions}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <VideocamIcon />
                    </InputAdornment>
                  ),
                }
              }}
            />
          </Grid>
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          {displayBlurToggle && (
            <Box display="flex" justifyContent="flex-start" pt={3}>
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={isVideoFilterEnabled}
                    onChange={_e => toggleVideoFilter()}
                    value="outlined"
                    color="secondary"
                  />
                )}
                label={l10n.sessions.backgroundBlur}
              />
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
